var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isAgentLogin == _vm.AGENT_LOGIN_ROLE_VAL.AGENT_ADMIN)?_c('agent-home'):_c('normal-home')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }